'use strict';

export default function() {
  $(document).delegate('#updateRetailerBtn', 'click', function() {
    var url = $('#prefferedRetailerId').val();
    if (url.indexOf('=') != -1) {
      var start = url.indexOf('=');
      var length = url.length;
      var store = url.substring(start + 1, length);
      ACC.track.trackPreferredRetailer(store);
    }
    $.ajax({
      url: url,
      type: 'POST',
      success: function() {
        $('#updateRetailerDiv').css('display', 'none');
      },
    });
  });
}

function disableOrderSubmitButton() {
  $('#orderSubmitButton').addClass('disabled');
  $('#orderSubmitButton').prop('disabled', true);
}

function enableOrderSubmitButton() {
  $('#orderSubmitButton').removeClass('disabled');
  $('#orderSubmitButton').removeProp('disabled');
}

function populateStepUpIframe(url, jwt) {
  const stepUpHtml = `<form id="stepupForm" name="stepupForm" method="POST" action="${url}">
     <input type="hidden" name="JWT" value="${jwt}">
      <script type="text/javascript">
        window.onload = function(){ document.getElementById('stepupForm').submit(); }
     </script>`;

  $('#payer-auth-iframe').attr('src', 'data:text/html;charset=utf-8,' + encodeURI(stepUpHtml));
}

$(document).delegate('#placeOrderForm1', 'submit', function() {
  disableOrderSubmitButton();
});

function getDeviceCollectionIframeContents(jwt, url) {
  return `
         <!DOCTYPE html>
         <html>
           <head>
           </head>
           <body>
             <form id="collectionForm" name="devicedata" method="POST" action="${url}">
               <input type="hidden" name="JWT" value="${jwt}" />
             </form>
             <script>
               document.getElementById('collectionForm').submit();
             </script>
           </body>
         </html>
       `;
}

function populateResponseFields(responseData) {
  /* populates the hidden field in cybersourceCheckoutSummaryPage
   for the BE to use when the form submits to the validate endpoint */
  $('#enrollmentCheckTransactionStatus').val(responseData.transactionStatus);
  $('#enrollmentResponseReasonCode').val(responseData.reasonCode);
  $('#enrollmentResponseTransactionId').val(responseData.authenticationTransactionId);
}

function transactionStatusCheck(responseData) {
  const transactionStatus = responseData.transactionStatus ? responseData.transactionStatus : '';

  if (transactionStatus === 'PENDING') {
    // card is enrolled and step up is required
    $('#payer-auth-modal').foundation('open');
    $('#payer-auth-modal').one('closed.zf.reveal', enableOrderSubmitButton);
    populateStepUpIframe(responseData.stepUpUrl, responseData.accessToken);
  } else {
    /* This handles the proceed to authorization (reason code = 100) case
		and error cases where the BE will redirect based on hidden fields */
    $('#placeOrderForm1').submit();
  }
}

function payerAuthCompleteCheck(event) {
  // check for payerAuthComplete event data message
  return (
    event.data &&
    event.data.messageType &&
    event.data.messageType === 'payerAuthComplete' &&
    event.origin === window.location.protocol + '//' + window.location.host
  );
}

/* This listens for the postMessage from the payerAuthComplete page which lets us
  know when to close the payerAuthIframe and submit the form to the validate endpoint */
window.addEventListener(
  'message',
  function(event) {
    if (payerAuthCompleteCheck(event)) {
      // close the modal & Iframe
      $('#payer-auth-modal').foundation('close');
      // submit the form to the validate endpoint
      $('#placeOrderForm1').submit();
    }
  },
  false
);

$(document).ready(function() {
  // Create payer auth device collection iframe
  const jwtHolder = $('#payerAuthDeviceAccessToken');
  const deviceCollectionUrl = $('#payerAuthDeviceCollectionURL');
  if (jwtHolder && jwtHolder.val()) {
    const deviceCollectionIframe = document.createElement('iframe');
    deviceCollectionIframe.width = 1;
    deviceCollectionIframe.height = 1;
    deviceCollectionIframe.style = 'display: none';
    document.body.append(deviceCollectionIframe);
    deviceCollectionIframe.contentDocument.write(
      getDeviceCollectionIframeContents(jwtHolder.val(), deviceCollectionUrl.val())
    );
  }

  // When we are using 3D Secure for added payer authentication
  $('#orderSubmitButton[data-cybersource-payer-auth-enabled]').click(function(evt) {
    // If Terms & Conditions is not checked, submit to backend normally and it will reload the page showing an error.
    // Otherwise, we're going to check with backend to see if we need to pop open a modal window to load the bank's iframe
    if ($('#Terms1').is(':checked')) {
      evt.preventDefault();
      disableOrderSubmitButton();
      $.ajax({
        url: 'enrollmentCheck',
        type: 'POST',
        data: $('#placeOrderForm1').serialize(),
        success: function(response) {
          populateResponseFields(response.data);
          transactionStatusCheck(response.data);
        },
        error: function(error) {
          enableOrderSubmitButton();
          console.log(error);
        },
      });
    } else {
      $('#placeOrderForm1').submit();
    }
  });
});
